import React from "react";
import logoLight from "../../Assets/logo_light.svg";

function FooterLogo() {
  return <img id="footerImg" src={logoLight} alt="" />;
}

export default FooterLogo;
